<h2 *transloco="let t">
  {{
    config.tenant === tenants.FR
      ? t("taxReturns.view-change-logs")
      : t("taxReturns.change-history")
  }}
</h2>

@if (!taxReturn) {
<div class="ui active centered inline loader"></div>
} @if (taxReturn) {
<div class="body">
  <div class="left-bar">
    <h3>{{ "taxReturns.snapshots" | transloco }}</h3>
    <div class="scrollable-content">
      @for (snapshot of snapshots; track snapshot; let i = $index) {
      <ol
        class="snapshot"
        [ngClass]="{
          selected: selectedSnapshotRange && i >= firstIndex && i <= lastIndex
        }"
        [start]="i + 1"
        (click)="selectSnapshot($event, snapshot)"
      >
        <li>
          <div class="status-name">
            @if (snapshot.status.phase.badge) {
            <div
              class="phase-badge"
              [ngClass]="snapshot.status.phase.id"
              [title]="snapshot.status.phase.name"
            >
              <div class="badge-text">{{ snapshot.status.phase.badge }}</div>
            </div>
            }
            <span>{{ snapshot.status.snapshotName }}</span>
          </div>
          <div class="summary">
            @if (snapshot.changed) {
            <div>
              @if (snapshot.numAnswersAdded) {
              <div>
                {{ snapshot.numAnswersAdded }} answer{{
                  snapshot.numAnswersAdded === 1 ? "" : "s"
                }}
                added
              </div>
              } @if (snapshot.numAnswersUpdated) {
              <div>
                {{ snapshot.numAnswersUpdated }} answer{{
                  snapshot.numAnswersUpdated === 1 ? "" : "s"
                }}
                updated
              </div>
              } @if (snapshot.numComments) {
              <div>
                {{ snapshot.numComments }} comment{{
                  snapshot.numComments === 1 ? "" : "s"
                }}
              </div>
              } @if (snapshot.numWarningsOpened) {
              <div>
                {{ snapshot.numWarningsOpened }} warning{{
                  snapshot.numWarningsOpened === 1 ? "" : "s"
                }}
                opened
              </div>
              } @if (snapshot.numWarningsClosed) {
              <div>
                {{ snapshot.numWarningsClosed }} warning{{
                  snapshot.numWarningsClosed === 1 ? "" : "s"
                }}
                closed
              </div>
              } @if (snapshot.numFlagsOpened) {
              <div>
                {{ snapshot.numFlagsOpened }} flag{{
                  snapshot.numFlagsOpened === 1 ? "" : "s"
                }}
                opened
              </div>
              } @if (snapshot.numFlagsClosed) {
              <div>
                {{ snapshot.numFlagsClosed }} flag{{
                  snapshot.numFlagsClosed === 1 ? "" : "s"
                }}
                closed
              </div>
              } @if (snapshot.numFlagComments) {
              <div>
                {{ snapshot.numFlagComments }} flag comment{{
                  snapshot.numFlagComments === 1 ? "" : "s"
                }}
              </div>
              }
            </div>
            } @if (!snapshot.changed) {
            <div>{{ "taxReturns.no-activity" | transloco }}</div>
            }
          </div>
        </li>
      </ol>
      }
    </div>
  </div>
  <div class="main-content" [ngClass]="{ active: !!selectedSnapshotRange }">
    @if (!selectedSnapshotRange) {
    <div>
      {{
        "taxReturns.select-a-snapshot-from-the-left-to-begin-shift-click-to-select-a-range"
          | transloco
      }}
    </div>
    } @if (selectedSnapshotRange) {
    <div class="selected-snapshot" [ngClass]="{ loading: loadingSelectionSub }">
      @if (selectedSnapshotRange.status) {
      <h3 class="title">
        @if (selectedSnapshotRange.endDateString) {
        <span>{{ "taxReturns.viewing-snapshot" | transloco }}</span>
        } @if (!selectedSnapshotRange.endDateString) {
        <span>{{ "taxReturns.viewing-current-status" | transloco }}</span>
        } @if (selectedSnapshotRange.status.phase.badge) {
        <span
          class="phase-badge"
          [ngClass]="selectedSnapshotRange.status.phase.id"
          [title]="selectedSnapshotRange.status.phase.name"
        >
          <span class="badge-text">{{
            selectedSnapshotRange.status.phase.badge
          }}</span>
        </span>
        }
        <span>{{ selectedSnapshotRange.status.snapshotName }}</span>
      </h3>
      } @if (!selectedSnapshotRange.status) {
      <h3>
        {{ selectedSnapshotRange.title }}
      </h3>
      }
      <div class="summary">
        <div>
          @if (selectedSnapshotRange.users.length === 1) {
          <b>{{ "taxReturns.user" | transloco }}</b>
          } @if (selectedSnapshotRange.users.length > 1) {
          <b>{{ "taxReturns.users" | transloco }}</b>
          }
          <span>{{
            selectedSnapshotRange.users.map(makeName).join(", ")
          }}</span>
          @if (selectedSnapshotRange.startedByUser) {
          <div>
            <b>{{ "taxReturns.started" | transloco }}</b>
            {{
              makeName(selectedSnapshotRange.startedByUser)
            }}&nbsp;&nbsp;-&nbsp;&nbsp;{{
              selectedSnapshotRange.startDateString
            }}
          </div>
          } @if (!selectedSnapshotRange.startedByUser) {
          <div>
            <b>{{ "taxReturns.started" | transloco }}</b>
            {{ selectedSnapshotRange.startDateString }}
          </div>
          } @if (selectedSnapshotRange.endDateString &&
          selectedSnapshotRange.finishedByUser) {
          <div>
            <b>{{ "taxReturns.finished" | transloco }}</b>
            {{
              makeName(selectedSnapshotRange.finishedByUser)
            }}&nbsp;&nbsp;-&nbsp;&nbsp;{{ selectedSnapshotRange.endDateString }}
          </div>
          } @if (selectedSnapshotRange.endDateString &&
          !selectedSnapshotRange.finishedByUser) {
          <div>
            <b>{{ "taxReturns.finished" | transloco }}</b>
            {{ selectedSnapshotRange.endDateString }}
          </div>
          }
          <div>
            <b>{{ "taxReturns.complexity" | transloco }}</b>
            @if (selectedSnapshotRange.complexity.length === 0) {
            <span>{{ "taxReturns.not-calculated" | transloco }}</span>
            } @for (c of selectedSnapshotRange.complexity; track c) {
            <span
              class="complexity-icon"
              title="{{ c.title }} ({{ c.complexity }})"
              [ngClass]="{
                'complexity-low': c.complexity == 1,
                'complexity-medium': c.complexity == 2,
                'complexity-high': c.complexity == 3
              }"
            >
            </span>
            }
          </div>
        </div>
      </div>
      <div class="links">
        <div>
          <a
            target="_blank"
            [routerLink]="selectedSnapshotRange.viewLink.href"
            [queryParams]="selectedSnapshotRange.viewLink.query"
          >
            @if (selectedSnapshotRange.endDateString) {
            <span
              >{{ 'taxReturns.view-tax-return-alias-at-end-of-snapshot' | transloco: {taxReturnAlias} }}</span
            >
            } @if (!selectedSnapshotRange.endDateString) {
            <span
              >{{ 'taxReturns.view-in-progress-tax-return-alias' | transloco: {taxReturnAlias} }}</span
            >
            }
          </a>
        </div>
      </div>
      <div class="divider"></div>
      <div class="scrollable-content">
        <div class="changes">
          @if (selectedSnapshotRange.answerChangesArray.length === 0) {
          <div>{{ "taxReturns.no-change" | transloco }}</div>
          } @for (subcategoryChange of selectedSnapshotRange.subcategoryChanges;
          track subcategoryChange) {
          <details class="subcategory-change">
            <summary>
              <div class="subcategory-header">
                <div class="subcategory-name">
                  {{ subcategoryChange.subcategory.name }}
                </div>
                <div class="subcategory-info">
                  @if (subcategoryChange.numWarningsAffected) {
                  <span class="notification-icon warnings-highlighted">
                    <span class="count">{{
                      subcategoryChange.numWarningsAffected
                    }}</span>
                  </span>
                  } @if (subcategoryChange.numFlagsAffected) {
                  <span class="notification-icon flags-highlighted">
                    <span class="count">{{
                      subcategoryChange.numFlagsAffected
                    }}</span>
                  </span>
                  } @if (subcategoryChange.numComments) {
                  <span class="notification-icon comments-highlighted">
                    <span class="count">{{
                      subcategoryChange.numComments
                    }}</span>
                  </span>
                  }
                  <a
                    class="view"
                    target="_blank"
                    [routerLink]="
                      makeViewLink(
                        selectedSnapshotRange.snapshots,
                        subcategoryChange.subcategory
                      ).href
                    "
                    [queryParams]="
                      makeViewLink(
                        selectedSnapshotRange.snapshots,
                        subcategoryChange.subcategory
                      ).query
                    "
                    ><i class="icon external alternate"></i
                  ></a>
                </div>
              </div>
            </summary>
            @for (groupChange of subcategoryChange.groupChanges; track
            groupChange) {
            <div class="group-change">
              @if (groupChange.group.id) {
              <h4>
                Tab name:{{ "taxReturns.tab-name" | transloco }}
                @if (groupChange.group.name) {
                <span>{{ groupChange.group.name }}</span>
                } @if (!groupChange.group.name) {
                <span class="empty">{{ "taxReturns.empty" | transloco }}</span>
                }
              </h4>
              } @for (subgroupChange of groupChange.subgroupChanges; track
              subgroupChange) {
              <div class="subgroup-change">
                <h5>{{ subgroupChange.subgroup.name }}</h5>
                @if (subgroupChange.answerChangesByParentId) { @for (obj of
                subgroupChange.answerChangesByParentId; track obj; let i =
                $index) {
                <div class="table-row">
                  <div>{{ "taxReturns.row-i-1" | transloco }} {{ i + 1 }}</div>
                  @for (answerChange of obj.answerChanges; track answerChange) {
                  <ng-container
                    *ngTemplateOutlet="
                      answerchange;
                      context: { answerChange: answerChange }
                    "
                  ></ng-container>
                  }
                </div>
                } } @if (!subgroupChange.answerChangesByParentId) { @for
                (answerChange of subgroupChange.answerChanges; track
                answerChange) {
                <ng-container
                  *ngTemplateOutlet="
                    answerchange;
                    context: { answerChange: answerChange }
                  "
                ></ng-container>
                } }
              </div>
              }
            </div>
            }
          </details>
          }
        </div>
      </div>
      @if (loadingSelectionSub) {
      <div class="ui active loader"></div>
      }
    </div>
    }
  </div>
</div>
}

<ng-template #answer let-answer="answer">
  @if (answer) {
  <span>{{ answer }}</span>
  } @if (!answer) {
  <span class="empty">{{ "taxReturns.empty" | transloco }}</span>
  }
</ng-template>

<ng-template #answerchange let-answerChange="answerChange">
  <div class="answer-change">
    <div class="question">
      <b>{{ answerChange.question.question }}</b>
      <div class="icons-container">
        @if (answerChange.numWarningsAffected) {
        <span class="notification-icon warnings-highlighted">
          <span class="count">{{ answerChange.numWarningsAffected }}</span>
        </span>
        } @if (answerChange.numFlagsAffected) {
        <span class="notification-icon flags-highlighted">
          <span class="count">{{ answerChange.numFlagsAffected }}</span>
        </span>
        } @if (answerChange.numComments) {
        <span class="notification-icon comments-highlighted">
          <span class="count">{{ answerChange.numComments }}</span>
        </span>
        }
      </div>
    </div>
    <div>
      @if (answerChange.answerValueChange) {
      <span>
        @if (answerChange.answerValueChange.created) {
        <span class="answer">
          <ng-container
            *ngTemplateOutlet="
              answer;
              context: { answer: answerChange.answerValueChange.newAnswer }
            "
          ></ng-container>
        </span>
        } @if (!answerChange.answerValueChange.created) {
        <span class="answer">
          {{ "taxReturns.changed-from" | transloco }}
          <b
            ><ng-container
              *ngTemplateOutlet="
                answer;
                context: { answer: answerChange.answerValueChange.oldAnswer }
              "
            ></ng-container
          ></b>
          {{ "taxReturns.to" | transloco }}
          <b
            ><ng-container
              *ngTemplateOutlet="
                answer;
                context: { answer: answerChange.answerValueChange.newAnswer }
              "
            ></ng-container
          ></b>
        </span>
        }
      </span>
      } @if (!answerChange.answerValueChange) {
      <span class="no-change-container">
        <ng-container
          *ngTemplateOutlet="
            answer;
            context: { answer: answerChange.previousAnswerValue }
          "
        ></ng-container>
        <span class="no-change">{{ "taxReturns.no-change" | transloco }}</span>
      </span>
      }
    </div>
  </div>
</ng-template>
